import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { getSeen, getExpired } from "./selectors"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    seen: getSeen(state, props),
    expired: getExpired(state, props),
  }),
  actions: Creators,
})
